import apiClient from "../../../utils/clients/axios";

export const getPartyCode = async () => {
    const { data } = await apiClient.get(
      `/api/quality_control/master/list_party_code/`
    );
  
    return data;
  };
  